import { olympusService as e } from "../services/olympus/olympus.service.js";
import { useGameStore as t } from "../stores/game-store/useGameStore.js";
import { useSessionStore as n } from "../stores/session-store/useSessionStore.js";
import { useCallback as r, useMemo as i, useState as a } from "react";
import { CSPWALogger as o, getDefaultUserSettings as s } from "@magnopus-opensource/connected-spaces-platform-web-api";
import { useShallow as c } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/shallow.mjs";
//#region src/lib/hooks/useCurrentUser.ts
var l = () => {
	let l = n((e) => e.setUserProfile), u = n((e) => e.setUserSettings), d = n((e) => e.userSettings), [f, p] = a(!1), [m, h] = a(!1), [g, _, v, y, b, x, S, C, w] = t(c((e) => [
		e.avatarId,
		e.avatarUrl,
		e.avatarType,
		e.avatarVisible,
		e.setAvatarType,
		e.setAvatarUrl,
		e.setAvatarVisible,
		e.setAvatarId,
		e.setAvatarPortrait
	])), T = r(async (t) => {
		if (d) {
			let n = {
				...d,
				...t
			};
			return u(n), e.client.users.settings.update(t), n;
		} else {
			console.warn("No user settings object to update.");
			return;
		}
	}, [u, d]), E = r(async () => {
		p(!0);
		let t = await e.client.users.getCurrentUserProfile(!0);
		l(t);
		let n = await e.client.users.getAvatarSettings(), r = n.id, i;
		i = await e.client.users.getAvatar(r), i.avatar === void 0 && i.skeleton === void 0 && (o.warning("avatar", "No avatar defined, reverting to the default avatar"), r = "", i = await e.client.users.getAvatar(r));
		let a = await e.client.users.getAvatarPortrait(r);
		b(n.type), C(r), S(n.visible), w(a), x(i.avatar?.uri);
		let c = await e.client.users.settings.get(), d = {
			type: n.type,
			avatarId: n.id,
			visible: n.visible
		};
		if (c) u({
			...c,
			avatar: d
		});
		else {
			let t = s();
			u({
				...t,
				avatar: d
			}), e.client.users.settings.update(t);
		}
		return e.currentUserId = t.id, h(!0), p(!1), {
			userProfile: t,
			avatarSettings: n,
			userSettings: c
		};
	}, [
		l,
		b,
		C,
		S,
		w,
		x,
		u
	]);
	return i(() => ({
		selectedAvatarId: g,
		selectedAvatarUrl: _,
		isUserLoading: f,
		loadCurrentUserDetails: E,
		updateSettings: T,
		hasLoaded: m,
		avatarType: v,
		avatarVisible: y
	}), [
		g,
		_,
		f,
		E,
		T,
		m,
		v,
		y
	]);
};
//#endregion
export { l as useCurrentUser };
